import request from "@/router/axios";
import store from "@/store";
import { Message } from "element-ui";

const httpRules = {
  state: {
    // 开启关闭状态
    openState: true,
    // 需要带上 项目id 条件的接口
    allowData: [],
    projectData: [],

    projectIdValue: "1",
    projectNameValue: "",
  },
  getters: {
    // 此接口是否需要添加 projectId
    projectIdNedd(state) {
      return (url) => state.allowData.includes(url);
    },

    // 获取 月的天数
    getMonthLength() {
      return (date) => {
        let d = new Date(date);
        // 将日期设置为下月一号
        d.setMonth(d.getMonth() + 1);
        d.setDate("1");
        // 获取本月最后一天
        d.setDate(d.getDate() - 1);
        return d.getDate();
      };
    },

    // 上传图片 大小判断
    whetherIsJPGIsPngIsJpeg() {
      return (file, size = 5) => {
        const isJPG = file.type === "image/jpg";
        const isPng = file.type === "image/png";
        const isJpeg = file.type === "image/jpeg";

        //限制文件上传类型
        if (!isJPG && !isPng && !isJpeg) {
          Message.error("上传图片只能是 png,jpg,jpeg 格式!");
          return false;
        }

        const isSize = file.size / 1024 / 1024 < size;

        //限制文件上传大小
        if (!isSize) {
          Message.error(`上传图片大小不能超过 ${size}MB!`);
          return false;
        }

        return true;
      };
    },
  },
  mutations: {
    //数据初始始化
    httpRulesOnload(data) {
      data.projectData = [];
      data.projectIdValue = "";
      data.projectNameValue = "";
    },
  },
  actions: {
    // 获取项目字典
    getProjectData({ commit, state }) {
      commit("httpRulesOnload");
      request({
        url: "/api/infox-masterdata/projectperson/user/projects",
        method: "get",
        params: {
          userId: store.state.user.userInfo.userId,
        },
      }).then((res) => {
        console.log(res);
        state.projectData = res.data.data;
        state.projectIdValue = state.projectData[0].id || "";
        state.projectNameValue = state.projectData[0].projectName || "";
      });
    },
  },
};

export default httpRules;
